import styled, { keyframes } from "styled-components";
import { slideInLeft } from "react-animations";

const menuAnimation = keyframes`${slideInLeft}`;

const MobileMenuStyleWrapper = styled.div`
    &.bithu_mobile_menu {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: auto;
        transition: 0.4s;
        opacity: 1;
        display: block;

        &::before {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            backdrop-filter: blur(10px);
            background: rgba(4, 12, 18, 0.9);
            content: "";
            z-index: -1;
        }
    }

    .bithu_mobile_menu_content {
        background: #000000;
        height: 100vh;
        width: 400px;
        padding: 50px;
        margin-right: auto;
        animation: 1s ${menuAnimation};
        overflow-y: scroll;
    }

    .mobile_menu_logo {
        width: 100%;
        position: relative;
    }

    .mobile_menu_close_btn {
        position: absolute;
        right: 0px;
        top: 50%;
        background: none;
        border: none;
        outline: none;
        transform: translateY(-50%);

        svg {
            color: #ffffff;
            font-size: 24px;
        }
    }

    .bithu_mobile_menu_list {
        margin-top: 20px;
        ul {
            margin: 0;
            padding: 0;

            li {
                height: 40px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                display: flex;
                align-items: center;
                justify-content: flex-start;
                position: relative;

                a {
                    text-decoration: none;
                    font-family: "Cinzel", sans-serif;
                    font-style: normal;
                    font-weight: 800;
                    font-size: 22px;
                    line-height: 22px;
                    text-align: center;
                    color: #fe9c01;
                    width: 100%;
                    transition: all 0.4s;

                    &:hover {
                        color: #fff;
                    }
                }
            }
        }
    }

    .connect_btn {
        display: block;
        width: 100%;
        margin: 30px auto 0;
        border: none;
        svg {
            margin-right: 20px;
            font-size: 20px;
        }
    }

    .iekbcc0.ju367va.ju367v1s {
        height: 50px;
        width: 100%;
        border: none;
        margin-top: 30px;
        background: #ba3505;
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &._12cbo8i3:hover {
            transform: scale(1) !important;
        }
        button {
            background: transparent;
            border-color: transparent;
            box-shadow: none;
        }
        .iekbcc0 {
            background: transparent;
            border-color: transparent;
        }
    }

    @media (max-width: 480px) {
        .bithu_mobile_menu_content {
            display: table-cell;
            width: 100%;
            padding: 10px 10px 10px 10px;
        }
    }
`;

export default MobileMenuStyleWrapper;
